export default {"src":"/_next/static/media/avax.6094d28d.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};